import { render, staticRenderFns } from "./BlankProperty.vue?vue&type=template&id=12b6853f&"
import script from "./BlankProperty.vue?vue&type=script&lang=js&"
export * from "./BlankProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports